export const isGooglePayLoaded = (): boolean => {
  try {
    return 'google' in (window || global) && !!google?.payments?.api?.PaymentsClient;
  } catch {
    return false;
  }
};
